import { FaDropbox, FaFolder } from "react-icons/fa";
import { useLocation, Link, useNavigate } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import LoadingDots from "../fleet/LoadingDots";
import { checkFileType } from "../fleet/Fleet";
import PdfViewer from "../fleet/PDFViewer";
import DocsViewer from "../fleet/DocViewer";
import { MdHideImage } from "react-icons/md";

const BASE_DIRECTORY = "/Company Training";
const TrainingDropBoxView = ({ api, title }) => {
	const [entries, setEntry] = useState([{ name: "placeholder" }]);
	const [hasFetched, setHasFetched] = useState(false);
	const param = useLocation().search.slice(6);
	const [dirArr, setDirArr] = useState(["Company Training"]);
	const [clickedImage, setClickedImage] = useState(null);
	const [clickedVideo, setClickedVideo] = useState(null); // video link
	const navigate = useNavigate();
	let videoRef = useRef(null);
	// to-do load more if the response's hasmore value is true, low priority, will never happen probably
	// to-do fix back / figure out navigation stack, low priority, it's just inconvinient
	// to-do hard fix the directory within the training data

	useEffect(() => {
		console.log(videoRef);
	}, clickedVideo);

	const FolderItem = ({ entry }) => {
		// craft new url and path
		let fileName = entry.name;
		let fileType = "";
		if (entry[".tag"] !== "folder") {
			fileType = checkFileType(fileName);
		} else {
			fileType = "folder";
		}
		let newPath = entry.path_display;
		return (
			<li className="p-1">
				{entry[".tag"] === "folder" ? (
					<Link to={`/training?path=${newPath}`} replace>
						<div className="flex gap-2 p-1">
							<FaFolder className="h-10 w-10" color="#0061FE" />
							<span className="mt-3 text-lg">{entry.name}</span>
						</div>
					</Link>
				) : fileType === "pdf" ? (
					<PdfViewer dropboxUrl={entry.link} title={fileName} path={entry.path_lower} />
				) : fileType === "doc" || fileType === "docx" ? (
					<DocsViewer docUrl={entry.link} title={fileName} />
				) : entry.isImage ? (
					<div className="flex gap-2 p-1">
						<img
							className="h-10 w-10 cursor-pointer"
							src={"data:image/jpeg;base64, " + entry.thumbnail}
							alt={entry.name}
							onClick={() => {
								setClickedImage(entry);
							}}
						/>
						<p
							onClick={() => {
								setClickedImage(entry);
							}}
							className="cursor-pointer mt-3 text-lg">
							{entry.name}
						</p>
					</div>
				) : entry.isVideo ? (
					<div className="flex gap-2 p-1">
						<img
							className="h-10 w-10 cursor-pointer"
							src={"data:image/jpeg;base64, " + entry.thumbnail}
							alt={entry.name}
							onClick={() => {
								setClickedVideo(entry.link);
							}}
						/>
						<p
							onClick={() => {
								setClickedVideo(entry.link);
							}}
							className="cursor-pointer mt-3 text-lg">
							{entry.name}
						</p>
					</div>
				) : (
					<div className="flex gap-2 items-center">
						<MdHideImage className="h-10 w-10" />
						<p className="mt-3 text-lg">Corrupt or non-supported file</p>
					</div>
				)}
			</li>
		);
	};
	const DirTraversalComponent = (index) => {
		let newPath = "/";
		for (let i = 0; i <= index.index; i++) {
			newPath += dirArr[i];
			if (i !== index.index) {
				newPath += "/";
			}
		}
		return (
			<>
				<Link to={`/training?path=${newPath}`} replace>
					<p className="mt-0.5 text-lg hover:text-blue-500 pr-1">{dirArr[index.index]}</p>
				</Link>
				<p className="mt-0.5 text-lg pr-1">/</p>
			</>
		);
	};

	const check_is_correct_path = () => {
		let directory_arr = decodeURI(param).split("/");
		if (directory_arr.length < 2 || directory_arr[1] !== "Company Training") {
			return false;
		}
		return true;
	};

	useEffect(() => {
		let dir = param;
		if (!param || !check_is_correct_path()) {
			dir = BASE_DIRECTORY;
		}
		dir = dir.split("&&")[0];
		const getData = async () => {
			///to-do need a check to make sure param can only start with /compnay target to prevent directory traversal attack
			try {
				await fetch(`${api}/dropbox/training?path=${dir}`, {
					method: "GET",
				})
					.then((res) => {
						if (res.ok) {
							return res.json();
						}
					})
					.then((res) => {
						setDirArr(decodeURI(dir).split("/").splice(1));
						setEntry(res["entries"]);
						setHasFetched(true);
					});
			} catch (error) {
				navigate("/training");
			}
		};

		if (!hasFetched) {
			getData();
		}
		return () => {};
	}, [api, param, entries, hasFetched, navigate, check_is_correct_path, setDirArr, dirArr]);

	useEffect(() => {
		setHasFetched(false);
	}, [param]);

	return clickedImage ? (
		<div
			className="fixed top-0 bottom-0 left-0 right-0 bg-black/50"
			onClick={() => {
				setClickedImage(null);
			}}>
			<div className="flex justify-center items-center h-full ">
				<img src={"data:image/jpeg;base64, " + clickedImage.thumbnail} alt="clicked" className="max-h-[90vh] w-auto" />
			</div>
		</div>
	) : clickedVideo ? (
		<div
			className="fixed top-0 bottom-0 left-0 right-0 bg-black/50 flex justify-center items-center"
			onClick={(e) => {
				if (videoRef.current) {
					videoRef.current.pause();
					videoRef.current.currentTime = 0;
				}
				setClickedVideo(null);
			}}>
			<video ref={videoRef} width="640" height="360" controls className=" h-2/3 w-2/3" onClick={(e) => e.stopPropagation()}>
				<source src={clickedVideo} type="video/mp4" />
				Your browser does not support the video tag.
			</video>
		</div>
	) : (
		<div>
			<div className="flex justify-center items-center gap-2 p-2">
				<FaDropbox size={50} color="#0061FE" />
				<p className="text-2xl font-bold">{title}</p>
			</div>
			<div className="items-center p-8">
				<div className="flex">
					<p className="font-bold text-xl pb-8">Training material: </p>
					<p className="mt-0.5 text-lg">/</p>
					{dirArr.map((_, index) => (
						<DirTraversalComponent index={index} key={index} />
					))}
				</div>

				{hasFetched ? (
					entries.length > 0 ? (
						<ul>
							{entries.map((entry) => (
								<FolderItem key={entry.id} entry={entry} />
							))}
						</ul>
					) : (
						<p className=" ml-4 text-lg">No files Found</p>
					)
				) : (
					<div className="flex gap-2 font-bold text-xl ml-2">
						<p>Files</p>
						<span className="flex">
							<LoadingDots />
						</span>
					</div>
				)}
			</div>
		</div>
	);
};
export default TrainingDropBoxView;
